import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import CustomerForm from './pages/CustomerForm';
import CustomerDetails from './pages/CustomerDetails';
import DocumentChecklist from './pages/DocumentChecklist';
import Reminders from './pages/Reminders';
import BirthdayReminders from './pages/BirthdayReminders';
import InsuranceReminders from './pages/InsuranceReminders';
import CustomerList from './pages/CustomerList';
import FollowUpReminders from './pages/FollowUpReminders';
import Insurence from './pages/Insurence';
import Report from './pages/Report';
import Employees from './pages/Employees';
import AddEmployee from './pages/AddEmployee';
import Contacts from './pages/Contact';
import AddContact from './pages/AddContact';
import EmpDashboard from './pages/EmpDashboard';
import AdminDashboard from './components/AdminDashboard';
import WhatsAppGenerator from './pages/WhatsAppGenerator';
import EnquiryPage from './pages/EnquiryPage';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Role-based redirect component
const RoleBasedRedirect = () => {
  const { employeeData } = useAuth();

  // Check if user is an employee/agent
  const isEmployee = employeeData &&
    (employeeData.role?.toLowerCase() === 'agent' || employeeData.role?.toLowerCase() === 'employee');

  if (isEmployee) {
    return <Navigate to="/emp-dashboard" replace />;
  }

  return <Navigate to="/dashboard" replace />;
};


function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Layout>
                <AdminDashboard />
              </Layout>
            </ProtectedRoute>
          } />

          {/* backward-compatible route: redirect old /AdminDashboard to /dashboard */}
          <Route path="/AdminDashboard" element={<Navigate to="/dashboard" replace />} />

          <Route path="/emp-dashboard" element={
            <ProtectedRoute>
              <Layout>
                <EmpDashboard />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/customer-list" element={
            <ProtectedRoute>
              <Layout>
                <CustomerList />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/customer/:id/edit" element={
            <ProtectedRoute>
              <Layout>
                <CustomerForm />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/add-customer" element={
            <ProtectedRoute>
              <Layout>
                <CustomerForm />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/document-checklist" element={
            <ProtectedRoute>
              <Layout>
                <DocumentChecklist />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/customer/:id" element={
            <ProtectedRoute>
              <Layout>
                <CustomerDetails />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/reminders" element={
            <ProtectedRoute>
              <Layout>
                <Reminders />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/follow-up-reminders" element={
            <ProtectedRoute>
              <Layout>
                <FollowUpReminders />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/birthday-reminders" element={
            <ProtectedRoute>
              <Layout>
                <BirthdayReminders />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/insurance-reminders" element={
            <ProtectedRoute>
              <Layout>
                <InsuranceReminders />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/loan-categories" element={
            <ProtectedRoute>
              <Layout>
                <CustomerList />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/loan-categories/auto/:subtype" element={
            <ProtectedRoute>
              <Layout>
                {/* AutoLoanDetail component removed — redirecting to Loan Categories */}
                <Navigate to="/loan-categories" replace />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/employees" element={
            <ProtectedRoute>
              <Layout>
                <Employees />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/add-employee" element={
            <ProtectedRoute>
              <Layout>
                <AddEmployee />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/employee/:id/edit" element={
            <ProtectedRoute>
              <Layout>
                <AddEmployee />
              </Layout>
            </ProtectedRoute>
          } />


          <Route path="/contacts" element={
            <ProtectedRoute>
              <Layout>
                <Contacts />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/add-contact" element={
            <ProtectedRoute>
              <Layout>
                <AddContact />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/edit-contact/:id" element={
            <ProtectedRoute>
              <Layout>
                <AddContact />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/insurance" element={
            <ProtectedRoute>
              <Layout>
                <Insurence />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/insurance/:id/edit" element={
            <ProtectedRoute>
              <Layout>
                <Insurence />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/reports" element={
            <ProtectedRoute>
              <Layout>
                <Report />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/whatsapp-reminder/:id" element={
            <ProtectedRoute>
              <Layout>
                <WhatsAppGenerator />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/enquiries" element={
            <ProtectedRoute>
              <Layout>
                <EnquiryPage />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/" element={
            <ProtectedRoute>
              <RoleBasedRedirect />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
